import { useState } from 'react';
import config from '../config';
import { Tool } from '../interfaces';

const useToolUpdate = () => {
  const [error, setError] = useState<string | null>(null);

  const toolUpdate = async (tool: Tool): Promise<Tool | null> => {
    try {
      const response = await fetch(`${config.centralApiBaseUrl}/tool`, {
        method: 'PUT',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(tool),
      });

      if (!response.ok) {
        throw new Error('Updating tool failed');
      }

      const data = await response.json();
      return data;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      return null;
    }
  };

  return { toolUpdate, error };
};

export default useToolUpdate;
